// components/SearchSection.tsx
import React from 'react';

interface SearchSectionProps {
  searchNome: string;
  searchCpf: string;
  onNomeChange: (value: string) => void;
  onCpfChange: (value: string) => void;
  dataLength: number;
}

export const SearchSection: React.FC<SearchSectionProps> = ({
  searchNome,
  searchCpf,
  onNomeChange,
  onCpfChange,
  dataLength,
}) => {
  if (dataLength === 0) return null;

  return (
    <div className="flex gap-6 w-full">
      <div className="flex flex-col w-1/2">
        <label className="mb-2 font-semibold text-blue-800">
          Pesquisar por Nome
        </label>
        <input
          type="text"
          value={searchNome}
          onChange={e => onNomeChange(e.target.value)}
          placeholder="Digite o nome"
          className="px-4 py-2 border border-blue-300 rounded-lg bg-blue-50 text-blue-900 font-medium focus:outline-none focus:ring-4 focus:ring-blue-100 focus:border-blue-600 transition"
        />
      </div>

      <div className="flex flex-col w-1/2">
        <label className="mb-2 font-semibold text-blue-800">
          Pesquisar por CPF
        </label>
        <input
          type="text"
          value={searchCpf}
          onChange={e => onCpfChange(e.target.value)}
          placeholder="Digite o CPF"
          className="px-4 py-2 border border-blue-300 rounded-lg bg-blue-50 text-blue-900 font-medium focus:outline-none focus:ring-4 focus:ring-blue-100 focus:border-blue-600 transition"
        />
      </div>
    </div>
  );
};
